module.exports = __webpack_public_path__ + "static/media/service-center-banner-mobile.11aec0ad.png";